/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Train_Card_DetailInputs */

const en_portal_step_train_card_detail = /** @type {(inputs: Portal_Step_Train_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 exercises · 50 min`)
};

const pl_portal_step_train_card_detail = /** @type {(inputs: Portal_Step_Train_Card_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 ćwiczeń · 50 min`)
};

/**
* | output |
* | --- |
* | "6 exercises · 50 min" |
*
* @param {Portal_Step_Train_Card_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_train_card_detail = /** @type {((inputs?: Portal_Step_Train_Card_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Train_Card_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_train_card_detail(inputs)
	return en_portal_step_train_card_detail(inputs)
});